window.labelProdutoComponent = {
    descricao: '',

    iniciar: function () {
        var self = this;

        global.ajax({
            url: "/Produto/LabelProdutoComponent",
            type: "post",
            success: function (data) {
                self.descricao = data;
            }
        });
    },

    aplicar: function (region) {

        if (!this.descricao) {
            return;
        }

        if (!region) {
            region = $('body');
        }

        if (!(region instanceof jQuery)) {
            region = $(region);
        }
        var $el = $('[labelProduto]', region);
        var descricao = this.descricao;
        $el.each(function () {
            var $this = $(this);
            var originalText = $this.text();
          
            $this.text(descricao);
            if ($this.hasAttr('column')) {
                var grid = $this.parents('[grid]:first');
                if (grid) {
                    var gridData = JSON.parse("{" + grid.attr("grid") + "}");
                    if (gridData) {
                        grid = GridController.get(gridData.nome);

                        if (grid) {
                            grid.renderActionButton();
                        }

                    }
                }
                
            }
            
        });
    }
};


